import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type StartDateTriggeredCommunicationState = {
  startDateTriggeredCommunicationsById: {
    [startDateTriggeredCommunicationId: number]: StartDateTriggeredCommunication;
  };
  startDateTriggeredCommunicationsStateByOrgId: StateDictionary;
};
type State = { startDateTriggeredCommunications: StartDateTriggeredCommunicationState };

const startDateTriggeredCommunicationsByIdSelector = (state: State) =>
  state.startDateTriggeredCommunications.startDateTriggeredCommunicationsById;
const startDateTriggeredCommunicationsSelector = createSelector(
  [startDateTriggeredCommunicationsByIdSelector],
  (startDateTriggeredCommunicationsById) => Object.values(startDateTriggeredCommunicationsById),
);
export const startDateTriggeredCommunicationForSurveyIdSelector = createSelector(
  [startDateTriggeredCommunicationsSelector, (_state: State, surveyId: number) => surveyId],
  (startDateTriggeredCommunications, surveyId) =>
    startDateTriggeredCommunications.find((s) => s.surveyId === surveyId),
);

export const startDateTriggeredCommunicationForOrgIdSelector = createSelector(
  [startDateTriggeredCommunicationsSelector, (_state: State, orgId: number) => orgId],
  (startDateTriggeredCommunications, orgId) =>
    startDateTriggeredCommunications.filter((s) => s.orgId === orgId),
);

const startDateTriggeredCommunicationsStateByOrgIdSelector = (state: State) =>
  state.startDateTriggeredCommunications.startDateTriggeredCommunicationsStateByOrgId;
export const startDateTriggeredCommunicationsStateForOrgIdSelector = createSelector(
  [startDateTriggeredCommunicationsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (startDateTriggeredCommunicationsStateByOrgId, orgId) =>
    startDateTriggeredCommunicationsStateByOrgId[orgId],
);
